module.exports = __webpack_public_path__ + "static/Gibson-Regular-webfont-1d1669090ade3a1c5e105dd7b2bd8467.ttf";